/**
 * Renders an email snippet with surrounding context from the original email.
 *
 * Handles two formats:
 * - Legacy: string snippet (plain text)
 * - Contextual: { before, highlight, after } object with highlighted match
 *
 * When contextual data is available, shows the highlight in yellow with
 * surrounding context in muted gray.
 */
export const ContextualSnippet = ({ snippet, context }) => {
  // Prefer context object (new format from snippet_context)
  if (context?.highlight) {
    return (
      <div className="whitespace-pre-line text-[11px] leading-relaxed">
        {context.before && (
          <>
            <span className="text-gray-400">{context.before}</span>
            {"\n"}
          </>
        )}
        <mark className="rounded-sm bg-yellow-100/80 px-0.5 font-medium text-gray-900">
          {context.highlight}
        </mark>
        {context.after && (
          <>
            {"\n"}
            <span className="text-gray-400">{context.after}</span>
          </>
        )}
      </div>
    );
  }

  // Legacy: plain string snippet
  if (typeof snippet === "string" && snippet) {
    return (
      <p className="whitespace-pre-line text-[11px] leading-relaxed text-gray-500">
        {snippet}
      </p>
    );
  }

  return null;
};
